import styled from '@emotion/styled'
import { Tabs, Tab } from '@mui/material'
import { colors } from '../../tokens/colors'
import { typography } from '../../tokens/typography'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
`

export const Title = styled.h1`
  ${typography.up5.regularSans};
  color: ${colors.copy.paragraphDark};
  margin: 0;
`

export const Description = styled.p`
  ${typography.baseline.regularSans};
  color: ${colors.copy.paragraphDark};
  margin: 0;
`

export const TabsContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 30px;
`

export const HorizontalLine = styled.div`
  flex: 1;
  height: 1px;
  background-color: ${colors.divider};
`

export const StyledTabs = styled(Tabs)`
  background: ${colors.common.white};
  width: fit-content;
  height: 42px;
  border-radius: 24px;
  border: 1px solid ${colors.divider};
  min-height: unset;
  overflow: hidden;

  .MuiTabs-indicator {
    display: none;
  }

  .MuiTabs-flexContainer {
    height: 100%;
    position: relative;
    gap: 2px;
  }

  .MuiTabs-scroller {
    overflow: hidden !important;
  }
`

export const StyledTab = styled(Tab)`
  ${typography.baseline.regularSans}
  text-transform: none;
  font-size: 13px;
  line-height: 18px;
  color: ${colors.copy.paragraphDark};
  min-height: unset;
  border-radius: 28px;
  padding: 6px 16px;
  background: transparent;
  transition: all 0.2s ease;
  white-space: nowrap;
  border-right: none;

  &::after {
    display: none;
  }

  &.Mui-selected {
    background-color: #2a6cac;
    color: ${colors.background.paper};
  }
`
